module.exports = __webpack_public_path__ + "img/7_no.610bb203.svg";